import React, { FC, useEffect } from 'react';
import { LandscapeCommoditiesTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';
import cn from 'classnames';
import styles from './LandscapeCommoditiesPage.module.css';
import {
  deleteCommodityLandscape,
  fetchCommoditiesByLandscapeId,
} from '../../../store/tradeAPI/commodity/reducers/commodity-landscape.slice';

interface LandscapeCommoditiesPageProps {}

const LandscapeCommoditiesPage: FC<LandscapeCommoditiesPageProps> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams();
  const { commoditiesLandscape, status } = useSelector(
    (state: RootState) => state.commodityLandscapeSlice
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchCommoditiesByLandscapeId(id));
    }
  }, [dispatch, id]);

  const handleEdit = (commodityId: string) => {
    navigate(`/landscapes/edit/${id}/commodities/edit/${commodityId}`);
  };

  const handleDelete = async (commodityId: string) => {
    if (id) {
      await dispatch(
        deleteCommodityLandscape({ existingId: commodityId, landscapeId: id })
      );
      dispatch(fetchCommoditiesByLandscapeId(id));
    }
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.landscapeCommoditiesWrapper)}>
      <LandscapeCommoditiesTemplate
        commodities={commoditiesLandscape ?? []}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default LandscapeCommoditiesPage;
